var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"yj-breadcrumb__item"},[_c('span',{ref:"link",class:['yj-breadcrumb__inner', _vm.to ? 'is-link' : ''],attrs:{"role":"link"}},[_vm._t("default")],2),_vm._v(" "),(_vm.separatorClass)?_c('i',{staticClass:"yj-breadcrumb__separator",class:_vm.separatorClass}):_c('span',{staticClass:"yj-breadcrumb__separator",attrs:{"role":"presentation"}},[_vm._v(_vm._s(_vm.separator))])])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/breadcrumb-item/src/breadcrumb-item.vue